<template>
  <div>
    <search-list :projectList="projectList" @findData="findData"></search-list>
    <div class="page-wrapper">
      <table-list
        title=""
        :columns="columns"
        :current="current"
        :data="tableList"
        :total="total"
        :loading="loading"
        @change-page="changPage"
      >
      </table-list>
    </div>
    <handle-modal :n="HandleKey" :visitFid="visitFid" :uid="uid" @refresh="findData(searchData)"></handle-modal>
    <img-show :n="imgN" :src="imgSrc"></img-show>
  </div>
</template>

<script type="text/ecmascript-6">

  import { deepClone } from '@/utils/format'
  import { getBaseUrl } from "@/utils/public";
  import SearchList from './components/SearchList'
  import HandleModal from './components/HandleModal'
  import TableList from 'components/TableList/index';
  import { getTaskReminderMsg,getList} from 'api/workBench'
  import ImgShow from 'components/ImgListShow/index'
  import {getProjects } from 'api/common'

  export default {
    created() {
    },
    components: {
      SearchList,
      TableList,
      HandleModal,
      ImgShow
    },
    data() {
      return {
        uid:"",
        imgN: 0,
        imgSrc: [],
        visitFid:'',
        HandleKey:0,
        currentVisitLog:[],
        current:1,
        total:0,
        searchData: {
          projectFid: '',
          shouldVisitDateFrom:'',
          shouldVisitDateTo:'',
          visitDateFrom:'',
          visitDateTo:'',
          visitStatus: '',
          stockFid:'',
          page: 1,
          limit: 10
        },
        loading:true,
        btnLoading:false,
        columns:[
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title:' '
          },
          {
            title: '项目名称',
            key: 'projectName',
            width:160,
            align: 'center'
          },
          {
            title: '合同号',
            key: 'contractCode',
            align: 'center',
            width:180
          },
          {
            title: '房间/床位号',
            key: 'stockNum',
            align: 'center',
            width:120
          },
          {
            title: '入住人',
            key: 'personName',
            align: 'center',
            width:220,
          },
          {
            title: '签约日期',
            key: 'signDateStr',
            align: 'center',
            width:120,
          },
          {
            title: '应回访日',
            key: 'shouldVisitDateStr',
            width:120,
            align: 'center',
          },
          {
            title: '实际回访日',
            key: 'visitDateStr',
            align: 'center',
            width:120

          },
          {
            title: '回访内容',
            key: 'remark',
            width:200,
            align: 'center',
            render: (h, params) => {
              if (params.row['remark'] && params.row['remark'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['remark']),
                  h('span', {}, params.row['remark'].slice(0, 7) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['remark'])
              }
            }
          },
          {
            title: "图片",
            key: "imgUrls",
            width:100,
            align: "center",
            render: (h, params) => {
              return (params.row['imgUrls'] && params.row['imgUrls'].length > 0) ? h('a', {
                on: {
                  click: () => {
                    this.imgSrc = params.row['imgUrls']
                    this.imgN++
                  }
                }
              }, '查看') : h('span', {}, '无')
            }
          },
          {
            title: '回访类型',
            key: 'visitTypeName',
            width:100,
            align: 'center'
          },
          {
            title: '签约类型',
            key: 'contractTypeName',
            width:100,
            align: 'center'
          },
          {
            title: '租约类型',
            key: 'rentTypeName',
            width:100,
            align: 'center'
          },
          {
            title: '回访状态',
            key: 'visitStatusName',
            width:100,
            align: 'center'
          },
          {
            title: '回访人',
            key: 'visitZoName',
            width:100,
            align: 'center'
          },
          {
            title: '操作',
            key: 'action',
            width:100,
            fixed:'right',
            align: 'center',
            render: (h,params)=>{
              return h('div',[h('a',{
                style: {
                  marginRight: '5px',
                  display: params.row.visitStatus==1?  'inline-block':'none'
                },
                on:{
                  click: () => {
                     var svDate = params.row.shouldVisitDate;
                     var nowDate = new Date();
                     var iDates = parseInt(Math.abs(svDate - nowDate) / 1000 / 60 / 60 / 24);
                    if(iDates>15) {
                      this.$Message.error('请在应回访日前后15天内录入回访')
                    }
                    else {
                      this.visitFid=params.row['fid']
                      this.uid = params.row['customerUid']
                      this.HandleKey++
                    }

                  }
                }
              },'跟进'),])
            }
          },
        ],
        tableList:[],
        projectList:[]
      }
    },
    methods: {
      changPage(n){
        this.loading = true;
        this.current = n;
        this.searchData.page = n
        this.getTableList()
      },
      findData(searchData){
        this.loading = true;
        this.current = 1;
        this.searchData = searchData
        this.searchData.page = 1
        this.getTableList()
      },
      getTableList() {
        getList(this.searchData).then( res => {
          this.tableList = res.data.list
          this.total = res.data.total

        }).finally(()=>{
          this.loading = false
        })
      },
      selectItem(selection){
        this.currentVisitLog = selection
      },
    }
  };
</script>

<style lang="css" scoped>
  .btn {
    margin-bottom: 16px;
  }

</style>
